import { Icon } from "@iconify/react";
import Translate from "./Translate";

const Button = ({
  type = "primary",
  label,
  icon,
  loading,
  disabled,
  onClick,
}) => {
  const isDisabled = loading || disabled;

  const clipPath =
    "rounded-3xl";

  const iconClipPath =
    "";

  if (type === "primary") {
    return (
      <button
        className={`
          w-full h-[60px] flex items-center justify-center gap-3 px-7 py-5 relative rounded-[50px] border-none whitespace-nowrap 
          before:content-[''] before:absolute before:inset-0 before:p-px before:rounded-[50px] 
          before:[background:linear-gradient(90deg,rgba(196,39,224,1)_0%,rgba(132,74,255,1)_47%,rgba(18,169,255,1)_100%)] 
          before:[-webkit-mask:linear-gradient(#fff_0_0)_content-box,linear-gradient(#fff_0_0)] 
          before:[-webkit-mask-composite:xor] before:[mask-composite:exclude] before:z-[1] before:pointer-events-none
          ${isDisabled ? "opacity-60 cursor-not-allowed" : "cursor-pointer hover:opacity-80"}
          bg-transparent text-white transition-all duration-300 ease-in-out
          text-center
        `}
        onClick={isDisabled ? undefined : onClick}
        disabled={isDisabled}
      >
        {!loading && icon && (
          <Icon icon={icon} className="w-5 h-5" />
        )}
        {loading ? (
          <>
            <Icon icon="svg-spinners:6-dots-scale-middle" className="w-6 h-6 text-white" />
            Processing...
          </>
        ) : (
          <span className="text-sm font-semibold">
            <Translate>{label}</Translate>
          </span>
        )}
      </button>
    );
  }

  // (rest unchanged)
  
  if (type === "secondary") {
    return (
      <div
        className={`relative h-[50px] bg-[#1C1C1C] ${clipPath} transition-all duration-200 hover:bg-opacity-80 group`}
      >
        <div className={`absolute inset-[3px] bg-[#444444] ${clipPath} `}>
          <button
            className={`absolute inset-[1px] bg-[#1C1C1C] ${clipPath} ${
              isDisabled ? "cursor-not-allowed" : "cursor-pointer"
            } flex items-center justify-center gap-2 text-white group-hover:opacity-80`}
            onClick={onClick}
            disabled={isDisabled}
          >
            {!loading && icon && (
              <Icon icon={icon} className="text-white w-4 h-4" />
            )}
            {loading && (
              <Icon
                icon="svg-spinners:6-dots-scale-middle"
                className="text-[#444444] w-6 h-6"
              />
            )}
            <Translate>{label}</Translate>
          </button>
        </div>
      </div>
    );
  }

  if (type === "danger") {
    return (
      <div
        className={`relative h-[50px] bg-red-900 ${clipPath} transition-all duration-200 ${
          !isDisabled && "hover:bg-opacity-80"
        } group overflow-hidden`}
      >
        <button
          className={`absolute inset-[1px] bg-[#1C1C1C] bg-opacity-80 ${clipPath} ${
            isDisabled
              ? "cursor-not-allowed"
              : "cursor-pointer group-hover:bg-opacity-50"
          } flex items-center justify-center gap-2 text-red-600 text-sm font-semibold`}
          onClick={onClick}
          disabled={isDisabled}
        >
          {!loading && icon && (
            <Icon icon={icon} className="text-red-600 w-4 h-4" />
          )}
          {loading && (
            <Icon
              icon="svg-spinners:6-dots-scale-middle"
              className="text-red-600 w-6 h-6"
            />
          )}
          <Translate>{label}</Translate>
        </button>
      </div>
    );
  }

  if (type === "icon" && icon) {
    return (
      <div className={`w-[40px] h-[40px] relative ${iconClipPath} bg-gradient`}>
        <button
          className={`absolute inset-[1px] ${iconClipPath} bg-[#1C1C1C] bg-opacity-60 hover:bg-opacity-90 cursor-pointer transition-all duration-200 flex items-center justify-center`}
          onClick={onClick}
        >
          <Icon icon={icon} className="text-white w-4 h-4" />
        </button>
      </div>
    );
  }

  return null;
};

export default Button;
